<template>
  <GeneralModal
    ref="modalBarcodeReaderRef"
    size="xxl"
    modalContentClass="p-4"
    @hidden="onHideModal"
    @shown="onShown"
    hideHeader
    hideHeaderClose
    hideFooter
    noCloseOnEsc
  >
    <template #bodyContent>
      <div class="barcode-scanner-container">
        <div id="barcode-scanner" class="scanner-view"></div>
        <p class="text-center text-muted mt-2">
          Asegúrate de que el código de barras esté dentro del recuadro.
        </p>
      </div>
    </template>
  </GeneralModal>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import Quagga from 'quagga'
import GeneralModal from '@/components/shared/GeneralModal.vue'

const emit = defineEmits(['readBarcode'])

const modalBarcodeReaderRef = ref(null)
const isScanning = ref(false)

onMounted(() => {
  console.log('Quagga está disponible:', Quagga)
})

onUnmounted(() => {
  Quagga.stop() // Asegura detener el escáner si el componente se desmonta
})

function onShown() {
  startBarcodeScanner()
}

function onHideModal() {
  Quagga.stop()
  isScanning.value = false
}

const startBarcodeScanner = () => {
  if (isScanning.value) return
  isScanning.value = true

  Quagga.init(
    {
      inputStream: {
        type: 'LiveStream',
        target: document.querySelector('#barcode-scanner'),
        constraints: {
          width: { min: 640, ideal: 1280, max: 1920 },
          height: { min: 480, ideal: 720, max: 1080 },
          facingMode: 'environment'
        }
      },
      decoder: { readers: ['ean_reader', 'ean_8_reader', 'ean_13_reader', 'upc_reader'] },
      locator: {
        halfSample: false,
        patchSize: 'medium', // Opciones: 'x-small', 'small', 'medium', 'large', 'x-large'
        debug: true
      },
      numOfWorkers: navigator.hardwareConcurrency || 4,
      frequency: 10
    },
    (err) => {
      if (err) {
        console.error('Error al iniciar escáner:', err)
        isScanning.value = false
        return
      }
      console.log('Escáner inicializado correctamente')
      Quagga.start()
    }
  )

  Quagga.onDetected((result) => {
    const scannedCode = result.codeResult.code
    console.log('Código escaneado:', scannedCode)

    if (scannedCode) {
      emit('readBarcode', scannedCode)
      hideModal() // Cierra el modal automáticamente tras un escaneo exitoso
    }
  })
}

const showModal = () => {
  modalBarcodeReaderRef.value.show()
}

const hideModal = () => {
  Quagga.stop()
  isScanning.value = false
  modalBarcodeReaderRef.value.hide()
}

defineExpose({ showModal, hideModal })
</script>

<style scoped>
.barcode-scanner-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.scanner-view {
  width: 100%;
  max-width: 600px;
  height: 400px;
  background: black;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}
</style>
